<template>
  <div class="golf-protection">
    <golf-protection-form v-if="golfProtectionForm" @golfForm="proceed()"></golf-protection-form>
    <div class="golf-protection-inner animate-slidein" v-else>
      <div class="golf-protection-info">
        <div class="status-image">
          <img src="/static/images/regluvardar_crown_logo.png" alt="logo" />
        </div>
        <h5>Vörður</h5>
        <h3>Golfvernd</h3>
        <p>Golfvernd er sérsniðin trygging fyrir kylfinga og gildir fyrir alla á heimilinu. Við viljum bjóða þér Golfvernd fyrsta árið á aðeins 5.315 kr.</p>
      </div>
      <div class="btn-wrapper">
        <button class="button buy" @click="buy()">Kaupa</button>
        <button class="button skip" @click="proceed()">Nei takk</button>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/shared/api'
export default {
  name: 'GolfProtection',
  props: ['currentLevel'],
  data () {
    return {
      golfProtectionForm: false,
      golfData: null,
      content: '',
      title: '',
      subtext: '',
      discount: '',
      golfStockImg: '',
      percentageImg: '',
      button1: null,
      button2: null,
      dataReady: false,
      url: null
    }
  },
  mounted () {
    let payload = {
      'email': this.$data.globalData.user.email,
      'level': this.currentLevel && this.currentLevel.name ? this.currentLevel.name : ''
    }
    API.meInstance.post('/quiz/golf/protection/', payload).then((res) => {
      this.dataReady = true
      this.golfData = res.data.golf_protection
      this.content = res.data.golf_protection.content
      this.title = res.data.golf_protection.heading
      this.subtext = res.data.golf_protection.sub_heading
      this.discount = res.data.golf_protection.discount_content
      this.golfStockImg = res.data.golf_protection.image_1
      this.button1 = res.data.golf_protection.button1
      this.button2 = res.data.golf_protection.button2
      this.url = res.data.golf_protection.url
      // this.percentageImg = res.data.golf_protection.image_2
    })
  },
  methods: {
    proceed () {
      this.$emit('proceedToQuiz')
      // this.$emit('playGame', true)
    },
    buy () {
      this.golfProtectionForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.golf-protection ~ div {
  height: 100%;
}
.golf-protection {
  position: relative;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: url('/static/images/Skoraðu-new-4-min.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  overflow: auto;
  background-position: bottom;
  .golf-protection-inner {
    opacity: 1;
    -webkit-animation-duration: 1s;
    animation-duration: 0.8s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: fadingEffectGolfProtection;
    animation-name: fadingEffectGolfProtection;
    flex: 1;
    max-width: 400px;
    margin: auto;
    padding-top: 50px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .golf-protection-info {
      margin-bottom: 133px;
    }

    img {
      width: 90px;
      height: 87px;
      margin-bottom: 22px;
    }

    h3, h5 {
      margin: 0;
      font-weight: 400;
      color: #FFFFFF;
      &:is(h5) {
        font-size: 16px;
        line-height: 19px;
      }
      &:is(h3) {
        font-weight: 600;
        margin-bottom: 45px;
      }
    }

    p {
      background: #FFFFFF;
      box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 19px 20px 15px;
      text-align: left;
    }
  }

  .btn-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-bottom: 32px;
    .button {
      margin-top: 0;
      max-width: 338px;
      width: 100%;
      &:first-child {
        margin-bottom: 14px;
      }
      &:last-child {
        background: #FFFFFF;
      }
    }
  }
}
.golf-percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.golf-protection-img {
  position: relative;
  max-width: 500px;
  img {
    border-radius: 10pt;
    width: 100%;
    height: 100%;
    max-width: 250px;
    max-height: 100%;
    @media screen and (min-width: 767px){
      max-width: 500px;
    }
    @media screen and (min-width: 1200px){
      max-width: 700px;
    }
  }
}
.golf-protection-img, .golf-percentage {
  display: inline-block;
  vertical-align: middle;
  img {
    width: 115px;
    height: 83px;
  }
  p {
    transform: rotate(-22deg);
    margin-top: -2rem;
    margin-left: 2rem;
  }
}
.golf-text {
  padding: 3rem 0;
}
.buy-btn {
  // margin-right: 1rem;
}
@media (max-width: 768px) {
  .golf-protection {
    background: url('/static/images/juan-gomez-unsplash_01.png');
    background-size: cover;
    padding: 0 18px;
    h1 {
      // display: none;
      opacity: 1;
    }
  }
}
@media (max-width: 480px) {
  .golf-text {
    padding: 3rem 1rem 0rem 1rem !important;
    min-height: 150px;
    overflow-y: auto;
  }
  .golfvernd-btn {
    margin-bottom: 20px;
  }
}
</style>
